var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReportePorUnidadGestion"),
      _vm._v(" "),
      _c("AprobarUnidadesProgramacionJefeJerarquico"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v("\n    Vacaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                slot: "activator",
                disabled: !this.valida_programacion,
                color: "rgba(103,15,121,0.6)"
              },
              on: {
                click: function($event) {
                  return _vm.aprobarUnidadesProgramacionJefeJerarquico({})
                }
              },
              slot: "activator"
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("play_arrow")]),
              _vm._v("Aprobar programación\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Aprobar")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _vm.loading_tabla
            ? _c("v-progress-circular", {
                attrs: {
                  size: 200,
                  width: 15,
                  color: "purple",
                  indeterminate: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading_tabla
            ? _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator" },
                              nativeOn: {
                                click: function($event) {
                                  return function() {
                                    _vm.filterShow = !_vm.filterShow
                                  }.apply(null, arguments)
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("filter_list")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Búsqueda/filtros")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("transition", { attrs: { name: "slide-fade" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filterShow,
                                expression: "filterShow"
                              }
                            ],
                            staticClass: "filter-container-rrhh"
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "primary" } },
                              [_vm._v("search")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item" },
                              [
                                _c("v-text-field", {
                                  attrs: { label: "Dependencia" },
                                  on: { input: _vm.filterNombreUnidad },
                                  model: {
                                    value: _vm.form.nombre_unidad,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "nombre_unidad", $$v)
                                    },
                                    expression: "form.nombre_unidad"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-item" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "btn-filter" },
                              [
                                _c(
                                  "v-tooltip",
                                  { attrs: { bottom: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          slot: "activator",
                                          icon: "",
                                          small: ""
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.recargar()
                                          }
                                        },
                                        slot: "activator"
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("refresh")
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Recargar filtros")])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  { attrs: { bottom: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { slot: "activator", icon: "" },
                                        nativeOn: {
                                          click: function($event) {
                                            return function() {
                                              _vm.filterShow = false
                                              _vm.recargar()
                                            }.apply(null, arguments)
                                          }
                                        },
                                        slot: "activator"
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("close")
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Cerrar filtros")])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1 tabla-comprimida-light",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.lista_unidades,
                      "no-data-text": "Sin datos",
                      "item-key": "id",
                      search: _vm.filters,
                      "custom-filter": _vm.customFilter,
                      "no-results-text": "No se encontro coincidencias",
                      "rows-per-page-items": [
                        25,
                        50,
                        { text: "Todos", value: -1 }
                      ]
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "headerCell",
                          fn: function(props) {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c("span", _vm._g({}, on), [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(props.header.text) +
                                                  "\n              "
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.header.text) +
                                        "\n            "
                                    )
                                  ])
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "items",
                          fn: function(items) {
                            return [
                              _c(
                                "td",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: {
                                    id:
                                      _vm.user.unidad[0].id ==
                                      items.item.id_unidad
                                        ? "celda"
                                        : ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(items.item.nombre_unidad) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: {
                                    id:
                                      _vm.user.unidad[0].id ==
                                      items.item.id_unidad
                                        ? "celda"
                                        : ""
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#6DE0BA",
                                        dark: "",
                                        icon: "",
                                        title:
                                          "Ver programaciones de vacaciones",
                                        to:
                                          "/ver-detalle-programacion-jerarquico/" +
                                          _vm.$route.params.gestion +
                                          "/" +
                                          items.item.id_unidad +
                                          "/" +
                                          _vm.$util.encodeString(
                                            items.item.nombre_unidad
                                          ) +
                                          "/" +
                                          _vm.$util.encodeString(
                                            items.item.item_jefe != ""
                                              ? items.item.item_jefe
                                              : "10001"
                                          )
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("remove_red_eye")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.user.unidad[0].id != items.item.id_unidad
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "warning",
                                            icon: "",
                                            title: "Ver reporte de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReportePorUnidadGestion(
                                                items.item,
                                                1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("picture_as_pdf")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user.unidad[0].id == items.item.id_unidad
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "warning",
                                            icon: "",
                                            title: "Ver reporte de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReportePorUnidadGestion(
                                                items.item,
                                                5
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("picture_as_pdf")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3775151175
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f698d32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f698d32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/VacacionAprobarJefe2.vue
// module id = null
// module chunks = 